import * as types from '../action-types.js';

const initState = {
  zoom: 1
};

export default (state = initState, { type, data }) => {
  switch (type) {
    case types.RESET_ZOOM:
      return {
        ...state,
        zoom: data
      };
    default:
      return state;
  }
};
